import React from 'react';
import PropTypes from 'prop-types';

import ConversationItem from 'models/conversation_item';
import InlineAnnotatedContentContainer from 'components/lib/inline_annotated_content_container';
import SafeHtml from 'components/common/safe_html';

export default function EmailBody({ emailPlainTextFromHtml, item }) {
  const email = item.content;
  if (
    (!emailPlainTextFromHtml && !email.bodyPlain) ||
    (emailPlainTextFromHtml && !email.getNonQuotedPlainTextFromHtml() && !email.bodyPlain)
  ) {
    return null;
  }

  if ((item.isAgentItem() || item.isApiItem()) && email.bodyHtmlStripped) {
    return <SafeHtml className="emailItem-body-content-rich" html={email.bodyHtmlStripped} />;
  }

  let emailBody;
  if (emailPlainTextFromHtml) {
    emailBody = email.getNonQuotedPlainTextFromHtml() || email.getNonQuotedPlainText();
  } else {
    emailBody = email.getNonQuotedPlainText();
  }

  return (
    <InlineAnnotatedContentContainer
      id={item.id}
      text={emailBody || ''}
      hasRedactedPaymentCard={email.hasRedactedPaymentCardNumber}
    />
  );
}

EmailBody.propTypes = {
  emailPlainTextFromHtml: PropTypes.bool,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/email/email_body.jsx